import { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { ESTILO_BOTON_GENERAL_ACEPTAR, ESTILO_BOTON_GENERAL_CANCELAR, ESTILO_INPUT_GENERICO } from "../../../utils/const-estilos";
import { capitalize } from "../../../share/shared-functions";
import { crearSubTipoCarroceria, modificarSubTipoCarroceria } from "../../../api/checklist";
import "../../../style/style-cargando.css";

export default function SubTipoCarroceria() {
  const location = useLocation();
  const history = useHistory();

  const [cargandoPage, setCargandoPage] = useState(true);
  const [subTipoCarroceria, setSubTipoCarroceria] = useState(null);
  const [titulo, setTitulo] = useState("");

  useEffect(() => {
    console.log("entro a SubTipoCarroceria");
    iniciar();
  }, []);

  const iniciar = () => {
    try {
      const data = location.state;
      console.log("data");
      console.log(data);
      if (data !== undefined && data !== null) {
        setSubTipoCarroceria(data.params);
        setTitulo(data.titulo);
      }
      setCargandoPage(false);
    } catch (err) {
      console.log('iniciar err');
      console.log(err);
      setCargandoPage(false);
    }
  }

  const nextPage = (page, params) => {
    history.push({
      pathname: `${page}`,
      state: params,
    });
  };

  const handleInputChange = (event) => {
    // console.log('handleInputChange');
    const { name, value } = event.target;
    // console.log(name);
    // console.log(value);
    setSubTipoCarroceria({ ...subTipoCarroceria, [name]: value });
  };

  const handleCancelClick = () => {
    history.goBack();
  };

  const handleSaveClick = async () => {
    // console.log('handleSaveClick');
    // lógica para guardar los cambios
    // console.log('subTipoCarroceria');
    // console.log(subTipoCarroceria);
    if (subTipoCarroceria.id > 0) {
      // console.log('actualizar sub tipo carroceria');
      let objModificar = {};
      objModificar.id = subTipoCarroceria.id;
      objModificar.idTipoCarroceria = subTipoCarroceria.idtipocarroceria;
      objModificar.descripcion = subTipoCarroceria.subtipocarroceria;
      let modificado = await modificarSubTipoCarroceria(objModificar);
      // console.log('creado');
      // console.log(creado);
      if (modificado === true) {
        alert('Se modifico correctamente');
        let obj = {};
        obj.idTipoCarroceria = subTipoCarroceria.idtipocarroceria;
        obj.nombreTipoCarroceria = subTipoCarroceria.tipoCarroceria;
        nextPage('listar-sub-tipo-carroceria', obj);
      }
      if (modificado === false) {
        alert('No se pudo modificar');
      }
    }
    if (subTipoCarroceria.id <= 0) {
      // console.log('crear sub tipo carroceria');
      let objCrear = {};
      objCrear.idTipoCarroceria = subTipoCarroceria.idtipocarroceria;
      objCrear.descripcion = subTipoCarroceria.subtipocarroceria;
      let creado = await crearSubTipoCarroceria(objCrear);
      // console.log('creado');
      // console.log(creado);
      if (creado === true) {
        alert('Se creo correctamente');
        let obj = {};
        obj.idTipoCarroceria = subTipoCarroceria.idtipocarroceria;
        obj.nombreTipoCarroceria = subTipoCarroceria.tipoCarroceria;
        nextPage('listar-sub-tipo-carroceria', obj);
      }
      if (creado === false) {
        alert('No se pudo crear');
      }
    }
  };

  const render = () => {
    // console.log('render sub tipo carroceria ');
    try {
      if (cargandoPage === true) {
        return (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              marginTop: 30,
            }}
          >
            <div className="loader"></div>
            <div
              style={{ marginTop: 10, }}
            >
              <p>Cargando...</p>
            </div>
          </div>
        );
      }
      if (cargandoPage === false && subTipoCarroceria === null) {
        return (
          <div>
            <label> Sin data</label>
          </div>
        );
      }
      return (
        <div className="min-h-screen bg-gray-100 flex flex-col  py-12 sm:px-6 lg:px-8">
          <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
            <h2 className="text-center text-3xl font-extrabold text-gray-900">
              {titulo}
            </h2>
            <div className="mt-6 bg-white py-6 px-4 shadow-md rounded-lg sm:px-10">
              <div className="space-y-6">
                <div>
                  <label
                    htmlFor="name"
                    className="block text-sm font-medium text-gray-700"
                  >
                    TIPO CARROCERIA
                  </label>
                  <div className="mt-1">
                    <input
                      id="tipoCarroceria"
                      name="tipoCarroceria"
                      type="text"
                      value={subTipoCarroceria.tipoCarroceria}
                      autoComplete="given-name"
                      className={ESTILO_INPUT_GENERICO}
                      readOnly
                    />
                  </div>
                </div>

                <div>
                  <label
                    htmlFor="name"
                    className="block text-sm font-medium text-gray-700"
                  >
                    {capitalize('Descripcion Sub Tipo Carroceria')}
                  </label>
                  <div className="mt-1">
                    <input
                      id="subtipocarroceria"
                      name="subtipocarroceria"
                      type="text"
                      value={subTipoCarroceria.subtipocarroceria}
                      onChange={handleInputChange}
                      autoComplete="given-name"
                      className={ESTILO_INPUT_GENERICO}
                      required
                    />
                  </div>
                </div>

                <div className="flex justify-end">
                  <div
                    style={{
                      justifyContent: 'space-between',
                      display: 'flex',
                      width: '100%'
                    }}
                  >
                    <button
                      type="button"
                      className={ESTILO_BOTON_GENERAL_CANCELAR}
                      onClick={handleCancelClick}
                    >
                      Cancelar
                    </button>
                    <button
                      type="button"
                      className={ESTILO_BOTON_GENERAL_ACEPTAR}
                      onClick={handleSaveClick}
                    >
                      Aceptar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    } catch (err) {
      console.log('subtipocarroceria render err');
      console.log(err);
      return (
        <div>
          <label>{JSON.stringify(err)}</label>
        </div>
      );
    }
  }

  return render();
}
